'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/ref.js
// module id = 970
// module chunks = 0